import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const categorySlice = createSlice({
  name: "category",

  initialState: {
    categoryData: [],
    isError: false,
  },

  reducers: {
    fetchCategorySuccess: (state, action) => {
      state.isError = false;
      state.categoryData = action.payload;
    },
    fetchCategoryFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchCategorySuccess, fetchCategoryFailure } =
  categorySlice.actions;

export const fetchCategory = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/category`);
    dispatch(fetchCategorySuccess(response.data.category));
  } catch (error) {
    dispatch(fetchCategoryFailure());
  }
};

export default categorySlice.reducer;
